const SelfAssessmentReport = () => {
    return(
        <div>Reports!</div>
    )
}

export default SelfAssessmentReport;